import React, { useEffect, useState } from "react";
import "../../Styles/NFTbox.css";
import { Col, Container, Row } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import Dashboardheader from "../../directives/dashboardheader";
import config from "../../config/config";
import toast from "react-hot-toast";
import Web3 from "web3";
import Cookies from "js-cookie";
import {
  getboxDetailsAction,
  getBoxInvestmentHistoryAction
} from "../../Action/user.action";

const NftboxDetails = () => {
  const navigate = useNavigate();
  const [nftBoxDetails, setNftBoxDetails] = useState([]);
  const [nftHystory, setnftHystory] = useState([]);
  const [page, setPage] = useState(1);
  const [paginationStatus, setpaginationStatus] = useState(false);
  let { nftBoxValue } = useParams();

  useEffect(() => {
    if (nftBoxValue == 0) {
      navigate(`${config.baseUrl}nftbox`);
    } else {
      getDataForNftDetails();
    }
  }, []);

  useEffect(() => {
    getBoxInvestmentHistory();
  }, [page]);

  const handleAddMore = () => {
    navigate(`${config.baseUrl}nftbox`, { state: { nftBoxValue } });
  };

  const getDataForNftDetails = async () => {
    try {
      const res = await getboxDetailsAction();
      if (res.success) {
        setNftBoxDetails(res.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getBoxInvestmentHistory = async () => {
    try {
      const data = {
        page: page,
        limit: 12,
      };
      const res = await getBoxInvestmentHistoryAction(data);
      if (res.data.history.length == 0) {
        setpaginationStatus(true);
      }
      if (res.success) {
        setnftHystory((prevData) => [...prevData, ...res.data.history]);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleLoadMore = () => {
    setPage(page + 1);
  };

  return (
    <>
      <Dashboardheader />
      <div className="position-relative">
        <div className="db1"></div>
        {/* <div className="db3"></div> */}
        <div className="db4"></div>
        <div className="db5"></div>
        <div className="db6"></div>
        <div className="db7"></div>
        <div className="db8"></div>

        <Container className="py-5">
          <Row className="gy-3 ">
            <Col>
              <div className="nftbox-card3 d-flex flex-column justify-content-center text-white h-100 px-4 pt-4 py-3">
                <Row>
                  <Col>
                    <h3 style={{ fontWeight: 700 }} className="sofia-sans">NFT Box</h3>
                    {/* <p className="nft-card-no mb-1 sofia-sans">Total Subscription</p> */}
                  </Col>
                  <Col className="text-end mt-1">
                    {/* <h5 className="sofia-sans" style={{ fontWeight: 600 }}>
                      {" "}
                      {nftBoxDetails.amount_usd} 
                    </h5> */}
                    <p  className="nft-card-no mb-1 sofia-sans">
                      {nftBoxDetails.amount_mnt}
                    </p>
                  </Col>
                </Row>
                {/* <img src="assets/images/nftbackground.png" className="position-absolute" style={{opacity:0.4}} alt="" /> */}
                <div className="w-100 d-flex flex-row justify-content-center gap-4">
                  <img src="assets/images/nftbox2.svg" alt="" />
                  <img
                    className="glow-img"
                    src="assets/images/nftbox1.svg"
                    alt=""
                  />
                  <img src="assets/images/nftbox2.svg" alt="" />
                </div>
              </div>
            </Col>
            <Col
              style={{ border: "1px solid #ffffff50", borderRadius: 10 }}
              className="d-flex flex-column align-items-center justify-content-center py-3 mx-2"
            >
              <Row className="gy-3">
                <Col lg={12}>
                  <div className="nft-details-column highlight d-flex justify-content-between p-2">
                    <p className="mb-0">Category</p>
                    <p className="mb-0">{nftBoxDetails.category_name}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2 ">
                    <p className="mb-0">Valid Till</p>
                    <p className="mb-0">{nftBoxDetails.validity}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2">
                    <p className="mb-0">Max Steps</p>
                    <p className="mb-0">{nftBoxDetails.max_steps}</p>
                  </div>
                </Col>
                <Col lg={12}>
                  <div className="nft-details-column d-flex justify-content-between p-2">
                    <p className="mb-0">Per Day Reward</p>
                    <p className="mb-0">{nftBoxDetails.reward_percent}</p>
                  </div>
                </Col>

                {/* <Col
                  lg={12}
                  className=" d-flex px-0 align-items-center justify-content-center"
                >
                  <Row className="gy-2 px-0  w-100">
                    <Col lg={12} className=" d-flex justify-content-center">
                      <button
                        className="nftbox-submit w-100"
                        onClick={handleAddMore}
                      >
                        {" "}
                        Add More Amount
                      </button>
                    </Col>
                  </Row>
                </Col> */}
              </Row>
            </Col>
          </Row>
          <br />
          <br />

          <Container>
            <div className="latest_transaction  mb-5 text-white">
              <h3 className="sofia-sans">Transaction History</h3>
              <div className="table-responsive mt-3">
                <table width="100%" className="text-center card-view sofia-sans">
                  <thead>
                    <tr className="table-head">
                      <th>S.No</th>
                      <th>Amount</th>
                      <th>Subscription Date</th>
                      <th>Credit Used</th>
                      <th>Expiry Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {nftHystory?.map((item, index) => (
                      <tr className="tr_list" key={index}>
                        <td>{index + 1}</td>
                        <td>
                          {item.amount_mnt} {item.coinname}
                        </td>
                        <td>{item.investment_date}</td>
                        <td>{item.credit_used} ANANT</td>
                        <td>{item.expiry_date}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {nftHystory.length == 0 ? (
                  <div
                    className="text-center d-flex justify-content-center align-items-center flex-column "
                    style={{
                      padding: "20px",
                      color: "#d3d3d3",
                      borderRadius: "8px",
                      height: "60vh",
                    }}
                  >
                    <img
                      style={{ width: "auto", height: "auto" }}
                      src="assets\images\newdesign\nodata-new.png"
                    />
                    <h4>No data found</h4>
                  </div>
                ) : (
                  <>
                    {nftHystory.length >= 10 && (
                      <>
                        {!paginationStatus && (
                          <center>
                            <div
                              onClick={handleLoadMore}
                              className="gap-2 mt-2 py-3 joined-user"
                              style={{
                                color: "white",
                                cursor: "pointer",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "black",
                                width: 180,
                                borderRadius: 8,
                              }}
                            >
                              <div className="ani-container">
                                <div className="chevron"></div>
                                <div className="chevron"></div>
                                <div className="chevron"></div>
                              </div>
                              <div style={{ fontWeight: 500 }} className="">
                                Load More
                              </div>
                            </div>
                          </center>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          </Container>
        </Container>
      </div>
    </>
  );
};

export default NftboxDetails;
